import "./App.css";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import SiteHeader from "./components/SiteHeader";
import SiteFooter from "./components/SiteFooter";
import ChatWidget from "./components/ChatWidget";
import HomePage from "./pages/HomePage";
import TechnologyPage from "./pages/TechnologyPage";
import ApplicationsPage from "./pages/ApplicationsPage";
import TeamPage from "./pages/TeamPage";
import PartnersPage from "./pages/PartnersPage";
import NewsPage from "./pages/NewsPage";
import CareersPage from "./pages/CareersPage";
import ContactPage from "./pages/ContactPage";
import AdminPage from "./pages/AdminPage";

const TOAST_OPTIONS = {
  style: {
    background: "#0a0a0a",
    border: "1px solid rgba(255,255,255,0.1)",
    borderRadius: "0px",
    color: "#fff",
    fontFamily: "JetBrains Mono, monospace",
    fontSize: "12px",
    textTransform: "uppercase",
    letterSpacing: "0.15em",
  },
};

function NotFound() {
  return (
    <main className="min-h-[60vh] flex items-center justify-center px-6">
      <div className="text-center">
        <div className="font-mono-tech text-[11px] uppercase tracking-widest text-white/50">
          404 / off-axis
        </div>
        <h1 className="mt-3 font-display font-black text-6xl tracking-tighter">
          Page not found.
        </h1>
        <Link
          to="/"
          data-testid="not-found-home"
          className="mt-6 inline-block font-mono-tech text-[11px] uppercase tracking-widest u-link"
        >
          ← Return to overview
        </Link>
      </div>
    </main>
  );
}

function App() {
  return (
    <HelmetProvider>
      <div className="App dark">
        <BrowserRouter>
          <SiteHeader />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/technology" element={<TechnologyPage />} />
            <Route path="/applications" element={<ApplicationsPage />} />
            <Route path="/team" element={<TeamPage />} />
            <Route path="/partners" element={<PartnersPage />} />
            <Route path="/news" element={<NewsPage />} />
            <Route path="/careers" element={<CareersPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <SiteFooter />
          <ChatWidget />
          <Toaster
            theme="dark"
            position="top-right"
            toastOptions={TOAST_OPTIONS}
          />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
